import styled from '@emotion/styled';

export const MessageWrapper = styled.div`
  padding: 60px 0;
`;

export const ActionWaiting = styled.div`
  font-size: 16px;
`;

export const ActionButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 16px;
`;

export const MerchantDataTableContainer = styled.div`
  .hover-button-wrapper {
    visibility: hidden;
  }

  .rdt_TableRow:hover .hover-button-wrapper {
    visibility: visible;
  }
`;

export const FilterContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  paddingright: 35px;
  margin-top: 20px;
  margin-bottom: 10px;

  > button {
    background: none;
    border: none;
    cursor: pointer;
    fontsize: 14px;
    display: flex;
    alignitems: center;
    gap: 5px;
  }

  .filter-dropdown {
    top: 20px;
  }
`;
